(function () {
  var DEFAULT_ENDPOINT = 'https://odyss-contact-form.odyss-life.workers.dev/submit';

  function initializeContactForms(root) {
    var sections = [];

    if (root.matches && root.matches('.odyss-partner-contact')) {
      sections = [root];
    } else if (root.querySelectorAll) {
      sections = Array.prototype.slice.call(root.querySelectorAll('.odyss-partner-contact'));
    }

    sections.forEach(function (section) {
      if (section.dataset.opcInitialized === 'true') return;

      var endpoint = (section.dataset.opcWorkerEndpoint || DEFAULT_ENDPOINT).trim();
      var form = section.querySelector('.opc-form');
      if (!form) return;

      section.dataset.opcInitialized = 'true';

      var successModal = section.querySelector('[data-opc-success-modal]');
      var successCloseButtons = section.querySelectorAll('[data-opc-success-close]');
      var submissionId = '';
      var previouslyFocusedElement = null;
      var submissionInProgress = false;

      function openSuccessModal() {
        if (!successModal) return;

        previouslyFocusedElement = document.activeElement;
        successModal.hidden = false;
        document.body.classList.add('opc-modal-open');

        var closeButton = successModal.querySelector('[data-opc-success-close]');
        if (closeButton) closeButton.focus({ preventScroll: true });
      }

      function closeSuccessModal() {
        if (!successModal || successModal.hidden) return;

        successModal.hidden = true;
        document.body.classList.remove('opc-modal-open');

        if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === 'function') {
          previouslyFocusedElement.focus({ preventScroll: true });
        }
      }

      Array.prototype.forEach.call(successCloseButtons, function (button) {
        button.addEventListener('click', closeSuccessModal);
      });

      if (successModal) {
        successModal.addEventListener('click', function (event) {
          if (event.target === successModal) closeSuccessModal();
        });
      }

      document.addEventListener('keydown', function (event) {
        if (!successModal || successModal.hidden) return;

        if (event.key === 'Escape') {
          closeSuccessModal();
        } else if (event.key === 'Tab') {
          var closeButton = successModal.querySelector('[data-opc-success-close]');
          if (closeButton) {
            event.preventDefault();
            closeButton.focus();
          }
        }
      });

      section.addEventListener('submit', async function (event) {
        var submittedForm = event.target;
        if (!submittedForm.matches || !submittedForm.matches('.opc-form')) return;

        event.preventDefault();
        event.stopPropagation();

        if (!submittedForm.checkValidity()) {
          submittedForm.reportValidity();
          return;
        }

        if (submissionInProgress) return;
        submissionInProgress = true;

        var submitButton = submittedForm.querySelector('[data-opc-submit]');
        var errorMessage = submittedForm.querySelector('[data-opc-error]');
        hideMessage(errorMessage);

        if (!submissionId) submissionId = createSubmissionId();

        var originalButtonLabel = submitButton ? submitButton.textContent : '';
        setSubmitting(submitButton, true);

        try {
          var response = await fetch(endpoint, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(buildPayload(submittedForm, submissionId))
          });
          var result = await response.json().catch(function () { return {}; });

          if (!response.ok || !result.ok) throw new Error('Submission failed');

          submittedForm.reset();
          submissionId = '';
          openSuccessModal();
        } catch (error) {
          showMessage(errorMessage);
        } finally {
          submissionInProgress = false;
          setSubmitting(submitButton, false, originalButtonLabel);
        }
      }, true);
    });
  }

  function buildPayload(form, submissionId) {
    return {
      submissionId: submissionId,
      partnershipType: checkedValue(form, 'contact[partnership_type]'),
      firstName: fieldValue(form, 'contact[first_name]'),
      lastName: fieldValue(form, 'contact[last_name]'),
      countryRegion: fieldValue(form, 'contact[country_region]'),
      city: fieldValue(form, 'contact[city]'),
      email: fieldValue(form, 'contact[email]'),
      phone: fieldValue(form, 'contact[phone]'),
      companyName: fieldValue(form, 'contact[company_name]'),
      industry: fieldValue(form, 'contact[industry]'),
      message: fieldValue(form, 'contact[body]'),
      termsAccepted: checkedValue(form, 'contact[terms_accepted]') === 'Yes',
      sourceUrl: window.location.href,
      referrer: document.referrer || '',
      website: fieldValue(form, 'website')
    };
  }

  function fieldValue(form, name) {
    var field = form.elements.namedItem(name);
    return field && typeof field.value === 'string' ? field.value.trim() : '';
  }

  function checkedValue(form, name) {
    var fields = form.querySelectorAll('[name="' + name + '"]');
    for (var index = 0; index < fields.length; index += 1) {
      if (fields[index].checked) return fields[index].value;
    }
    return '';
  }

  function setSubmitting(button, submitting, originalLabel) {
    if (!button) return;

    button.disabled = submitting;
    button.setAttribute('aria-busy', submitting ? 'true' : 'false');

    if (submitting) {
      button.textContent = button.dataset.submittingLabel || 'Submitting…';
    } else if (originalLabel) {
      button.textContent = originalLabel;
    }
  }

  function showMessage(element) {
    if (!element) return;
    element.hidden = false;
    element.focus({ preventScroll: true });
  }

  function hideMessage(element) {
    if (element) element.hidden = true;
  }

  function createSubmissionId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'odyss-' + Date.now() + '-' + Math.random().toString(36).slice(2, 12);
  }

  initializeContactForms(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeContactForms(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeContactForms(event.target);
  });
})();
